import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5003/api/v1";

// STUDY GROUP ENDPOINTS
export const getStudyGroups = (subject) => {
  return axios.get(`${API_BASE_URL}/study-groups`, {
    params: { subject }
  });
};

export const createStudyGroup = (data, token) => {
  console.log(token + "debugging")    ///debugging
  return axios.post(`${API_BASE_URL}/study-groups/create`, data, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const joinStudyGroup = (groupId, token, userId) => {
  return axios.post(`${API_BASE_URL}/study-groups/join/${groupId}`, { user_id: userId }, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const leaveStudyGroup = (groupId, token, userId) => {
  console.log(userId + "This is userID")
  return axios.post(`${API_BASE_URL}/study-groups/leave/${groupId}`, { user_id: userId }, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const deleteStudyGroup = (groupId, token) => {
  
  return axios.delete(`${API_BASE_URL}/study-groups/delete/${groupId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

// AUTH ENDPOINTS
export const signupUser = (data) => {
  return axios.post(`${API_BASE_URL}/auth/signup`, data);
};

export const loginUser = (data) => {
  return axios.post(`${API_BASE_URL}/auth/login`, data);
};

export const fetchQuiz = async () => {
  const token = localStorage.getItem('token');
  const res = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:5003/api/v1"}/study-groups/quiz/start`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.json();
};